import React from "react";
import { translate } from "../../Services/translation";
import { MediaType } from "../ProductItemTypes";
import ProductPageBuyButtonsContainer from "../../Containers/ProductPageBuyButtons.container";
import Price from "./Price";

/**
 *
 * @param {ProductItem} productItem
 * @param {boolean} openMiniCartAtCheckout
 * @returns {JSX.Element}
 * @constructor
 */
const ProductItem = ({
    productItem,
    openMiniCartAtCheckout = true
}) => {
    const isNewsToDate = productItem.isNewsToDate ? new Date(productItem.isNewsToDate) : null;
    const isNews = isNewsToDate && new Date() <= isNewsToDate;
    const mediaItem = productItem.images.find((mediaItem) => (mediaItem.type || '').toLowerCase() === MediaType.IMAGE) || null;

    return (
        <div className="card-item" itemScope itemType="http://schema.org/Product">
            {productItem.isNewsToDate && isNews && productItem.newsIcon && productItem.newsIcon.fullSrcUrl &&
                <div className="product__newproduct">
                    <img src={productItem.newsIcon.fullSrcUrl} alt="News Icon" itemProp="image" />
                </div>
            }

            <div className="card-item-container__link">
                {productItem.campaignIcon && productItem.campaignIcon.fullSrcUrl &&
                    <img
                        src={productItem.campaignIcon.fullSrcUrl}
                        alt="Campaign Icon"
                        className="campaign-icon"
                    />
                }

                <a href={productItem.url} itemProp="url">
                    <figure className="card-item__figure">
                        {mediaItem ?
                            <img
                                src={mediaItem.fullSrcUrl}
                                alt="Product"
                                itemProp="image"
                            />
                            :
                            <span className="card-item__missing">
                                {translate('product.noproductimage')}
                            </span>
                        }
                    </figure>
                </a>

                <article className="card-item__info">
                    <meta itemProp="description" content={productItem.description} />

                    {productItem.price.price &&
                        <meta
                            itemProp="sku"
                            content={productItem.price.price.unitOfMeasurementTitle}
                        />
                    }

                    <a href={productItem.url} itemProp="url" className="card-item__name">
                        <h3 itemProp="name">
                            {productItem.name}
                        </h3>
                    </a>

                    <a href={productItem.url} itemProp="url" className="card-item__price">
                        <div
                            itemProp="offers"
                            itemScope
                            itemType="http://schema.org/Offer"
                        >
                            {productItem.price && <Price {...{ productItem }} />}

                            {productItem.isInStock ?
                                <link itemProp="availability" href="http://schema.org/InStock" />
                                : <link itemProp="availability" href="http://schema.org/OutOfStock" />
                            }
                            <link itemProp="url" href={productItem.url} />
                        </div>
                    </a>

                    <div
                        className={'product-page-buy-buttons react-rendered' + (productItem.isBuyButtonDisabled ? ' disabled' : '')}>
                        <ProductPageBuyButtonsContainer
                            isMuurikka={true}
                            isProductPage={false}
                            productItem={productItem}
                            openMiniCartAtCheckout={openMiniCartAtCheckout}
                        />
                    </div>
                </article>
            </div>
        </div>
    );
}

export default ProductItem;
